import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { apiUrl } from "../config/api";
import { adminAuthHeaders } from "../utils/authHeaders";

// --- کامپوننت مودال تأیید ---
const ConfirmModal = ({ isOpen, title, message, onConfirm, onCancel }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h3>{title}</h3>
        <p>{message}</p>
        <div className="modal-buttons">
          <button onClick={onCancel} className="btn-cancel">انصراف</button>
          <button onClick={onConfirm} className="btn-confirm">تأیید</button>
        </div>
      </div>
    </div>
  );
};

const VitrinMasseges = () => {
  const [activeTab, setActiveTab] = useState('gallery');
  
  // وضعیت مودال تأیید
  const [confirmModal, setConfirmModal] = useState({
    isOpen: false,
    title: '',
    message: '',
    onConfirm: null
  });

  // وضعیت‌های گالری
  const [galleryItems, setGalleryItems] = useState([]);
  const [newGalleryTitle, setNewGalleryTitle] = useState('');
  const [newGalleryDesc, setNewGalleryDesc] = useState('');
  const [newGalleryImage, setNewGalleryImage] = useState(null);

  // وضعیت‌های پیام‌ها
  const [messages, setMessages] = useState([]);
  const [newMsgTitle, setNewMsgTitle] = useState('');
  const [newMsgContent, setNewMsgContent] = useState('');

  // بارگذاری داده‌ها
  useEffect(() => {
    fetchData();
  }, [activeTab]);

  const fetchData = async () => {
    try {
      if (activeTab === 'gallery') {
        const res = await axios.get(apiUrl('/api/content/gallery'));
        setGalleryItems(res.data);
      } else {
        const res = await axios.get(apiUrl('/api/content/daily-messages'));
        setMessages(res.data);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  // --- تابع کمکی برای نمایش مودال تأیید ---
  const showConfirm = (title, message, onConfirm) => {
    setConfirmModal({ isOpen: true, title, message, onConfirm });
  };

  const closeConfirm = () => {
    setConfirmModal({ isOpen: false, title: '', message: '', onConfirm: null });
  };

  // --- مدیریت گالری ---
  const handleGallerySubmit = async (e) => {
    e.preventDefault();
    if (!newGalleryImage) return alert('لطفاً یک تصویر انتخاب کنید');
    const formData = new FormData();
    formData.append('title', newGalleryTitle);
    formData.append('description', newGalleryDesc);
    formData.append('image', newGalleryImage);
    try {
      await axios.post(apiUrl('/api/content/gallery'), formData, {
        headers: adminAuthHeaders({ 'Content-Type': 'multipart/form-data' })
      });
      alert('تصویر با موفقیت اضافه شد');
      setNewGalleryTitle('');
      setNewGalleryDesc('');
      setNewGalleryImage(null);
      fetchData();
    } catch (error) {
      alert('خطا در افزودن تصویر');
    }
  };

  const deleteGalleryItem = async (id) => {
    showConfirm(
      'حذف تصویر',
      'آیا از حذف این مورد اطمینان دارید؟',
      async () => {
        try {
          await axios.delete(apiUrl(`/api/content/gallery/${id}`), {
            headers: adminAuthHeaders(),
          });
          fetchData();
        } catch (error) {
          alert('خطا در حذف');
        }
        closeConfirm();
      }
    );
  };

  // --- مدیریت پیام‌ها ---
  const handleMessageSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(apiUrl('/api/content/daily-messages'), {
        title: newMsgTitle,
        content: newMsgContent
      }, {
        headers: adminAuthHeaders({ 'Content-Type': 'application/json' }),
      });
      alert('پیام با موفقیت منتشر شد');
      setNewMsgTitle('');
      setNewMsgContent('');
      fetchData();
    } catch (error) {
      alert('خطا در ارسال پیام');
    }
  };

  const deleteMessage = async (id) => {
    showConfirm(
      'حذف پیام',
      'آیا از حذف این پیام اطمینان دارید؟',
      async () => {
        try {
          await axios.delete(apiUrl(`/api/content/daily-messages/${id}`), {
            headers: adminAuthHeaders(),
          });
          fetchData();
        } catch (error) {
          alert('خطا در حذف پیام');
        }
        closeConfirm();
      }
    );
  };

  return (
    <div className="admin-panel">
      <h2>پنل مدیریت محتوا</h2>
      
      {/* تب‌ها */}
      <div className="admin-tabs">
        <button 
          className={activeTab === 'gallery' ? 'active' : ''} 
          onClick={() => setActiveTab('gallery')}
        >
          مدیریت گالری
        </button>
        <button 
          className={activeTab === 'messages' ? 'active' : ''} 
          onClick={() => setActiveTab('messages')}
        >
          مدیریت پیام‌ها
        </button>
      </div>

      {/* محتوای تب گالری */}
      {activeTab === 'gallery' && (
        <div className="admin-section">
          <h3>افزودن تصویر جدید</h3>
          <form onSubmit={handleGallerySubmit}>
            <div>
              <label>عنوان:</label>
              <input 
                type="text" 
                value={newGalleryTitle} 
                onChange={(e) => setNewGalleryTitle(e.target.value)} 
                required 
              />
            </div>
            <div>
              <label>توضیحات:</label>
              <textarea 
                value={newGalleryDesc} 
                onChange={(e) => setNewGalleryDesc(e.target.value)} 
                required 
              />
            </div>
            <div>
              <label>تصویر:</label>
              <input 
                type="file" 
                accept="image/*" 
                onChange={(e) => setNewGalleryImage(e.target.files[0])} 
                required 
              />
            </div>
            <button type="submit">افزودن به گالری</button>
          </form>
          <h3>لیست تصاویر</h3>
          <table className="admin-table">
            <thead>
              <tr>
                <th>تصویر</th>
                <th>عنوان</th>
                <th>تعداد لایک</th>
                <th>عملیات</th>
              </tr>
            </thead>
            <tbody>
              {galleryItems.map(item => (
                <tr key={item.id}>
                  <td><img src={item.imageUrl} alt={item.title} width="50" /></td>
                  <td>{item.title}</td>
                  <td>{item.likes}</td>
                  <td>
                    <button onClick={() => deleteGalleryItem(item.id)} className="btn-delete">
                      حذف
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* محتوای تب پیام‌ها */}
      {activeTab === 'messages' && (
        <div className="admin-section">
          <h3>افزودن پیام جدید</h3>
          <form onSubmit={handleMessageSubmit}>
            <div>
              <label>عنوان پیام:</label>
              <input 
                type="text" 
                value={newMsgTitle} 
                onChange={(e) => setNewMsgTitle(e.target.value)} 
                required 
              />
            </div>
            <div>
              <label>متن پیام:</label>
              <textarea 
                value={newMsgContent} 
                onChange={(e) => setNewMsgContent(e.target.value)} 
                required 
              />
            </div>
            <button type="submit">انتشار پیام</button>
          </form>
          <h3>لیست پیام‌ها</h3>
          <table className="admin-table">
            <thead>
              <tr>
                <th>عنوان</th>
                <th>تاریخ انتشار</th>
                <th>عملیات</th>
              </tr>
            </thead>
            <tbody>
              {messages.map(msg => (
                <tr key={msg.id}>
                  <td>{msg.title}</td>
                  <td>{msg.date}</td>
                  <td>
                    <button onClick={() => deleteMessage(msg.id)} className="btn-delete">
                      حذف
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* مودال تأیید */}
      <ConfirmModal
        isOpen={confirmModal.isOpen}
        title={confirmModal.title}
        message={confirmModal.message}
        onConfirm={confirmModal.onConfirm}
        onCancel={closeConfirm}
      />
    </div>
  );
};

export default VitrinMasseges;
